import {addVoidForLinks, hamburger, viewPromoButton, menuOnMobile, profileSubmenu, toTop} from "./utils";
import {eventObject} from "./event";
import {filterEvent} from "./filter";
import user from "./user";
// import googleAnalytics from "./googleAnalytics";

const $ = window.jQuery;

$("html").removeClass("no-js");
addVoidForLinks($("a"));
hamburger("js-hamburger", "js-menu");
menuOnMobile();
viewPromoButton();
user();
profileSubmenu();
toTop();
filterEvent();
const csrfToken = $("meta[name='csrf-token']").attr("content");

// $(document).ready(() => {
// 	if (window.gaEnabled) googleAnalytics();
// });

eventObject.init();
$(".dropdown").ariaDropdown();

$(document).on("click", ".js-places-buy", e => {
    const el = $(e.currentTarget);
    e.preventDefault();
    eventObject.getFastRegistration();
    const sum = el
        .parents(".js-order")
        .find(".js-summ")
        .text();
    $(".js-summ-fast").text(sum);
    let action = $("#fast-registration-controller").attr("action");
    const eventId = el
        .parents(".js-order")
        .find(".js-promo")
        .data("event");
    const resultID = action.match(/event_id=\d*/);
    action = action.replace(resultID, `event_id=${eventId}`);
    $("#fast-registration-controller").attr("action", action);
});

const clearButton = $("#js-order-clear");

clearButton.on("click", () => {
    $.ajax({
        url: "/event/cart/remove-full",
        type: "POST",
        success: () => {
            window.location.reload();
        },
    });
});

let page = 1;

$("#js-more").on("click", () => {
    const firstDate = $(".events__item:last-child").data("first");
    const secondDate = $(".events__item:last-child").data("second");
    const dateRange = `${firstDate} — ${secondDate}`;

    $.ajax({
        url: "/search",
        data: {dateRange, page, "_csrf-frontend": csrfToken},
        type: "POST",
        beforeSend: () => {
            $("#js-overlay").show();
        },
        success: response => {
            const res = JSON.parse(response);

            if (res.html) {
                    $("#js-event-items").append(res.html);
                    page++;
            } else {
                $(".events__more").hide();
            }

            if (res.eventsCount.length < 5) {
                $("#js-more").hide();
            }
        },
        complete: () => {
            $("#js-overlay").hide();
        },
        error: error => {
            console.error("Error ", error);
        },
    });
});
